// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleAyurveda_root__usdaR","title":"ArticleAyurveda_title__FSG6L","viewMore":"ArticleAyurveda_viewMore__WM7Bs","link":"ArticleAyurveda_link__ZVFIO"};